export default __webpack_public_path__ + "static/media/moon.a914f989.jpeg";